export enum NotificationClassEnum {
  SUCCESS = "success-notification",
  ERROR = "error-notification",
  INFO = "info-notification",
  WARNING = "warning-notification"
}
export enum NoficationType{
  WARNING = "alert-warning",
  ERROR="alert-danger"
}
export interface NotificationBanner{
  message:string;
  type: NoficationType,
  icon: string;
}